export default __webpack_public_path__ + "static/media/shake-hands.48ecfaea.svg";